import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, useMediaQuery, useTheme } from "@mui/material";
import { ReactComponent as Logo } from "../../assets/svg/Logo.svg";
import { useNavigate } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import { getApiData } from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLoginButton from "../../components/SocialLogin/GoogleLoginButton";
import { useDispatch } from "react-redux";
import authActions from "../../redux/reducers/auth/actions";
import Images from "../../config/images";
import { ReactComponent as TabletLogo } from "../../assets/svg/TabletLogo.svg";

function HomeScreen() {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { setUserData, setToken } = authActions;

  const isTablet = useMediaQuery("(max-width:1024px)");
  const isMobile = useMediaQuery("(max-width:820px)");

  const [socialBtnLoad, setSocialBtnLoad] = useState(false);
  const [locationData, setLocationData] = useState({});

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => setLocationData(data))
      .catch((error) => console.error(error));
  }, []);

  // this function for to get location detail

  async function googleDataApiCall(googleCode) {
    try {
      setSocialBtnLoad("google");
      const response = await getApiData(Setting.endpoints.googleData, "POST", {
        code: googleCode,
      });

      if (response.success) {
        if (!isEmpty(response?.data)) {
          socialLoginApiCall(response?.data, "google");
        }
      } else {
        toast.error(response.message);
        setSocialBtnLoad("");
      }
    } catch (error) {
      console.log("🚀 ~ google data api call ~ error:", error);
      toast.error(error.toString());
      setSocialBtnLoad("");
    }
  }

  async function socialLoginApiCall(socialData, type) {
    setSocialBtnLoad(type);
    const address = `${locationData?.city ? locationData?.city + "," : ""} ${
      locationData?.region ? locationData?.region + "," : ""
    } ${locationData?.country_name || ""}`;
    try {
      const response = await getApiData(Setting.endpoints.login, "POST", {
        email: socialData?.email ? socialData?.email : "",
        password: socialData?.password ? socialData?.password : "",
        device_type: "web",
        social_connection: type ? type : "",
        device_name: locationData?.ip || "",
        login_address: address,
      });

      if (response.success) {
        dispatch(setToken(response?.token));
        if (response?.is_new_user) {
          setSocialBtnLoad("");
          navigate("/signup", {
            state: { socialData, type, data: response?.data },
          });
        } else if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          dispatch(setUserData(response?.data));
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else if (
          response?.is_phone_verified === false ||
          response?.data?.is_phone_verified === false
        ) {
          navigate("/phone-verify", {
            state: { data: response?.data, type: "phone" },
          });
        } else if (response?.is_role_added === false) {
          dispatch(setUserData(response?.data));
          navigate("/role");
        } else if (
          response?.data?.contractor_data &&
          response?.data?.contractor_data?.profile_completed === "pending"
        ) {
          dispatch(setUserData(response?.data));
          navigate("/create-profile");
        } else {
          dispatch(setUserData(response?.data));
          setSocialBtnLoad("");
          navigate("/dashboard");
        }
      } else if (response.success === false) {
        dispatch(setToken(response?.token));
        if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          dispatch(setUserData(response?.data));
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else if (
          response?.is_phone_verified === false ||
          response?.data?.is_phone_verified === false
        ) {
          navigate("/phone-verify", {
            state: { data: response?.data, type: "phone" },
          });
        } else {
          setSocialBtnLoad("");
          toast.error(response.message);
        }
      } else {
        setSocialBtnLoad("");
        toast.error(response.message);
      }
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ loginUser ~ error:", error);
      setSocialBtnLoad("");
      toast.error(error.toString());
    }
  }

  // Original desktop version
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: 'url("/assets/images/bg1.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        textAlign: "center",
        px: isMobile ? 10 : 3,
        pt: isMobile ? 4 : isTablet ? 4 : 8,
        overflowX: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: isMobile ? "35px" : isTablet ? "15px" : "20px",
        }}
      >
        <div>{isTablet ? <TabletLogo /> : <Logo />}</div>

        <div>
          <div
            style={{
              fontSize: isMobile ? "1.3rem" : isTablet ? "1.3rem" : "40px",
              fontWeight: "600",
              color: "#0D0D0E",
              letterSpacing: "-0.4px",
              fontFamily: "Inter Tight",
              marginBottom: "7px",
            }}
          >
            For contractors, designers and suppliers to
          </div>
          <div
            style={{
              fontSize: isMobile ? "1.3rem" : isTablet ? "1.3rem" : "40px",
              fontWeight: "600",
              color: "#4D6BF6",
              letterSpacing: "-0.4px",
              fontFamily: "Inter Tight",
              marginBottom: "7px",
            }}
          >
            streamline your workflow efficiency
          </div>
        </div>

        <Stack spacing={2}>
          <Stack
            direction="column"
            spacing={2}
            justifyContent="center"
            alignItems={"center"}
          >
            <Stack direction="row" spacing={2} justifyContent="center">
              <button
                style={{
                  width: "fit-content",
                  backgroundColor: "#4D6BF6",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  boxShadow: "none",
                  padding: isMobile
                    ? "1.5vh 10vw"
                    : isTablet
                    ? "1.5vh 2vw"
                    : "1.5vh 2vw",
                  width: isMobile ? "100%" : isTablet ? "13vw" : "100%",
                  border: "1px solid transparent",
                  color: "#fff",
                  cursor: "pointer",
                  fontFamily: "Inter Tight",
                }}
                onClick={() => navigate("/user-login")}
              >
                Login
              </button>

              <button
                style={{
                  width: "fit-content",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  boxShadow: "none",
                  color: "#0D0D0E",
                  border: "1px solid #1212151A",
                  padding: isMobile
                    ? "1.5vh 10vw"
                    : isTablet
                    ? "1.5vh 2vw"
                    : "1.5vh 2vw",
                  width: isMobile ? "100%" : isTablet ? "13vw" : "100%",
                  cursor: "pointer",
                  fontFamily: "Inter Tight",
                  whiteSpace: "nowrap",
                }}
                onClick={() => navigate("/signup")}
              >
                Join Reno
              </button>
            </Stack>

            <img src={Images.divider} alt="divider" />

            <GoogleOAuthProvider clientId={Setting.GOOGLE_CLIENT_ID}>
              <GoogleLoginButton
                loader={socialBtnLoad === "google"}
                onGoogleDone={(val) => googleDataApiCall(val?.code)}
              />
            </GoogleOAuthProvider>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}

export default HomeScreen;
